<div
    class="container bg-light page-light"
    >
    @if (bookingDetails) {
        <div
            appVenueColour
            [primaryColour]="venue?.primaryColour"
            class="row"
        >
            <div class="col-md-2 col-lg-3"></div>
            <div class="col-md-8 col-lg-6">
                <div class="vstack gap-4">
                    <div class="vstack align-items-center p-2 bg-white position-sticky top-0" style="z-index: 1020;">
                        <h5 class="m-0 fw-semibold">{{ bookingDetails.venueName }}</h5>
                    </div>
                    <div class="vstack">
                        <h5 class="fw-semibold">Select Your Menu Choices</h5>
                        <p class="text-muted">
                            Please submit your menu selections for this booking.
                        </p>
                        <div class="bg-white rounded-2 p-2">
                            <ng-container
                                [ngTemplateOutlet]="bookingSummary"
                                [ngTemplateOutletContext]="{ bookingDetails: bookingDetails }"
                            ></ng-container>
                        </div>
                    </div>

                    @if (menu && bookingDetails) {
                        <div class="vstack gap-2 mb-4">
                            <div class="hstack gap-2 justify-content-between align-items-center">
                                <h5 class="fw-semibold m-0">
                                    {{ menu.displayName }}
                                </h5>
                                <button
                                    type="button"
                                    class="btn btn-outline-secondary"
                                    (click)="openMenuView()"
                                >
                                    View Full Menu
                                </button>
                            </div>
                            <p class="text-muted">
                                {{ menu.description }}
                            </p>
                            
                            @if (hasCurrentUserSubmittedChoices()) {
                                <div class="alert alert-success border-0 shadow-sm">
                                    <div class="d-flex align-items-start gap-3">
                                        <div class="flex-shrink-0">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-check-circle-fill" viewBox="0 0 16 16">
                                                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
                                            </svg>
                                        </div>
                                        <div class="flex-grow-1">
                                            <h6 class="alert-heading fw-bold mb-2">Your Choices Have Been Submitted!</h6>
                                            <p class="mb-0">Thank you for submitting your menu selections. The restaurant has received your choices and will prepare your meal accordingly.</p>
                                        </div>
                                    </div>
                                </div>
                                
                                @if (currentUserChoices.length > 0) {
                                    <div class="bg-white rounded-2 p-3 vstack gap-2">
                                        <h6 class="fw-bold mb-0">Your Selections</h6>
                                        @for (v of currentUserChoices; track $index) {
                                            <div class="px-3 py-2 bg-light rounded">
                                                <div class="fw-semibold">
                                                    {{ v.productName }}
                                                </div>
                                                @if (v.modifierNames) {
                                                    <div class="small text-muted">{{ v.modifierNames }}</div>
                                                }
                                            </div>
                                        }
                                    </div>
                                }
                            } @else if (allChoicesEntered) {
                                <div class="alert alert-success">
                                    <strong>All choices submitted!</strong> Thank you for completing your menu selection.
                                </div>
                            } @else if (canAddMoreChoices) {
                                <div class="vstack gap-3">
                                    <button
                                        appVenueColour
                                        [primaryColour]="venue?.primaryColour"
                                        type="button"
                                        class="btn btn-primary btn-lg w-100"
                                        (click)="addMyChoices()"
                                    >
                                        Add My Choices
                                    </button>
                                    <p class="text-muted text-center small mb-0">
                                        You'll be asked for your name, then you can select your menu choices.
                                    </p>
                                </div>
                            } @else {
                                <div class="alert alert-info">
                                    All available spots have been filled. If you need to make changes, please contact the venue.
                                </div>
                            }
                        </div>
                    }
                </div>
            </div>
    </div> }
</div>

<ng-template
    #bookingSummary
    let-bookingDetails="bookingDetails"
>
    <div class="vstack gap-2">
        <div class="fw-semibold px-2 py-1 rounded-1 bg-light">
            Booking Summary
        </div>
        <div
            class="px-2 hstack gap-1 justify-content-between"
        >
            <label>
                Table for
            </label>
            <div class="text-truncate fw-semibold">
                {{ bookingDetails.partySize | i18nPlural: partySizePluralMapping }}
                ·
                {{ bookingDetails.dateTime | date: 'mediumDate' }}
            </div>
        </div>
        <div *ngIf="bookingDetails.requiresWheelchairAccess || bookingDetails.requiresDogFriendly || bookingDetails.requiresPramAccessible || bookingDetails.requiresHighchairFriendly" class="px-2 hstack gap-1 justify-content-between">
            <label>Booking Requirements</label>
            <div class="text-truncate fw-semibold">
                <ng-container *ngIf="bookingDetails.requiresWheelchairAccess">Wheelchair Access </ng-container>
                <ng-container *ngIf="bookingDetails.requiresDogFriendly">Dog Friendly</ng-container>
                <ng-component *ngIf="bookingDetails.requiresPramAccessible">Pram Accessible</ng-component>
                <ng-component *ngIf="bookingDetails.requiresHighchairFriendly">Highchair Friendly</ng-component>
            </div>
        </div>
        <div
            class="px-2 hstack gap-1 justify-content-between"
        >
            <label>
                Booking Type
            </label>
            <div
                class="text-truncate fw-semibold"
            >
                <ng-container
                    *ngIf="bookingDetails.eventId === null"
                >
                    Standard Booking
                </ng-container>
                <ng-container
                    *ngIf="bookingDetails.eventId !== null"
                >
                    {{ bookingDetails.eventName }}
                </ng-container>
            </div>
        </div>
        <div
            *ngIf="bookingDetails.reasonId !== null"
            class="px-2 hstack gap-1 justify-content-between"
        >
            <span class="flex-shrink-0">
                Reason for your visit
            </span>
            <div
                class="text-truncate fw-semibold"
            >
                {{ bookingDetails.reasonName }}
            </div>
        </div>
        <div
            *ngIf="bookingDetails.areaName !== null"
            class="px-2 hstack gap-1 justify-content-between"
        >
            <label>
                Seating Area
            </label>
            <div class="text-truncate fw-semibold">
                {{ bookingDetails.areaName }}
            </div>
        </div>
        <div
            class="px-2 hstack gap-1 justify-content-between"
        >
            <label>
                Time
            </label>
            <div
                class="text-truncate fw-semibold"
            >
                {{ bookingDetails.dateTime | date: 'shortTime' }}
            </div>
        </div>
    </div>
</ng-template>
